export default __webpack_public_path__ + "static/media/bestSmiley.f4a6a3fa.svg";